export const routes = (parentName) => {
  return [
    {
      path: "courses",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Courses`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Courses-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Courses-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Courses-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
